<template>
  <div class="page-wrapper">
    <div class="page-head">
      <h1>{{ $vuetify.lang.t('$vuetify.menu.catalog') }}</h1>

      <div class="page-head__buttons">
        <button v-if="permissions.edit.indexOf('Каталог') != -1" class="btn-secondary btn" @click="shopModal=true">
          {{ $vuetify.lang.t('$vuetify.shops') }}
        </button>
        <button v-if="permissions.edit.indexOf('Каталог') != -1" class="btn-secondary btn" @click="sellerModal=true">
          {{ $vuetify.lang.t('$vuetify.sellers') }}
        </button>
        <button v-if="permissions.edit.indexOf('Каталог') != -1" class="btn-secondary btn" @click="productCreateOpen">
          + {{ $vuetify.lang.t('$vuetify.addProduct') }}
        </button>
        <button class="btn-secondary btn" @click="arch = !arch; page=1">
          <span v-if="!arch">{{ $vuetify.lang.t('$vuetify.archive') }}</span>
          <span v-else>{{ $vuetify.lang.t('$vuetify.outArchive') }}</span>
        </button>
      </div>
    </div>

    <div class="page-head page-head--sorts">
      <div class="page__sorts">
        <v-text-field class="search-field" v-model="search" @keypress.enter="loadData()"
                      :placeholder="$vuetify.lang.t('$vuetify.sorts.searchName')" outlined
                      prepend-inner-icon="$search" hide-details>
        </v-text-field>
        <v-autocomplete class="sorts__select show" v-model="filter" :items="categories" return-object
                        :item-text="$vuetify.lang.current" clearable
                        :label="$vuetify.lang.t('$vuetify.accounting.card.category')" outlined attach
                        :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                      maxHeight: width<1024 ? 200 : 800,
                                      contentClass: 'select-menu select-menu--sort',
                                  }" hide-details>
        </v-autocomplete>
      </div>
      <div class="page-head--right">
        <per-page-select v-model="perPage"></per-page-select>
        <div class="type-switcher">
          <div class="type-switcher__item" :class="{ show: type == 'rows' }" @click="type = 'rows'">
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="33" height="33" rx="4.5"/>
              <path
                d="M9.20039 9.7998C8.723 9.7998 8.26516 9.98945 7.9276 10.327C7.59003 10.6646 7.40039 11.1224 7.40039 11.5998V13.9998C7.40039 14.4772 7.59003 14.935 7.9276 15.2726C8.26516 15.6102 8.723 15.7998 9.20039 15.7998H11.6004C12.0778 15.7998 12.5356 15.6102 12.8732 15.2726C13.2107 14.935 13.4004 14.4772 13.4004 13.9998V11.5998C13.4004 11.1224 13.2107 10.6646 12.8732 10.327C12.5356 9.98945 12.0778 9.7998 11.6004 9.7998H9.20039ZM8.60039 11.5998C8.60039 11.4407 8.6636 11.2881 8.77613 11.1755C8.88865 11.063 9.04126 10.9998 9.20039 10.9998H11.6004C11.7595 10.9998 11.9121 11.063 12.0247 11.1755C12.1372 11.2881 12.2004 11.4407 12.2004 11.5998V13.9998C12.2004 14.1589 12.1372 14.3115 12.0247 14.4241C11.9121 14.5366 11.7595 14.5998 11.6004 14.5998H9.20039C9.04126 14.5998 8.88865 14.5366 8.77613 14.4241C8.6636 14.3115 8.60039 14.1589 8.60039 13.9998V11.5998ZM16.4004 10.9998C16.2413 10.9998 16.0886 11.063 15.9761 11.1755C15.8636 11.2881 15.8004 11.4407 15.8004 11.5998C15.8004 11.7589 15.8636 11.9115 15.9761 12.0241C16.0886 12.1366 16.2413 12.1998 16.4004 12.1998H26.0004C26.1595 12.1998 26.3121 12.1366 26.4247 12.0241C26.5372 11.9115 26.6004 11.7589 26.6004 11.5998C26.6004 11.4407 26.5372 11.2881 26.4247 11.1755C26.3121 11.063 26.1595 10.9998 26.0004 10.9998H16.4004ZM16.4004 13.3998C16.2413 13.3998 16.0886 13.463 15.9761 13.5755C15.8636 13.6881 15.8004 13.8407 15.8004 13.9998C15.8004 14.1589 15.8636 14.3115 15.9761 14.4241C16.0886 14.5366 16.2413 14.5998 16.4004 14.5998H23.6004C23.7595 14.5998 23.9121 14.5366 24.0247 14.4241C24.1372 14.3115 24.2004 14.1589 24.2004 13.9998C24.2004 13.8407 24.1372 13.6881 24.0247 13.5755C23.9121 13.463 23.7595 13.3998 23.6004 13.3998H16.4004ZM9.20039 18.1998C8.723 18.1998 8.26516 18.3894 7.9276 18.727C7.59003 19.0646 7.40039 19.5224 7.40039 19.9998V22.3998C7.40039 22.8772 7.59003 23.335 7.9276 23.6726C8.26516 24.0102 8.723 24.1998 9.20039 24.1998H11.6004C12.0778 24.1998 12.5356 24.0102 12.8732 23.6726C13.2107 23.335 13.4004 22.8772 13.4004 22.3998V19.9998C13.4004 19.5224 13.2107 19.0646 12.8732 18.727C12.5356 18.3894 12.0778 18.1998 11.6004 18.1998H9.20039ZM8.60039 19.9998C8.60039 19.8407 8.6636 19.6881 8.77613 19.5755C8.88865 19.463 9.04126 19.3998 9.20039 19.3998H11.6004C11.7595 19.3998 11.9121 19.463 12.0247 19.5755C12.1372 19.6881 12.2004 19.8407 12.2004 19.9998V22.3998C12.2004 22.5589 12.1372 22.7115 12.0247 22.8241C11.9121 22.9366 11.7595 22.9998 11.6004 22.9998H9.20039C9.04126 22.9998 8.88865 22.9366 8.77613 22.8241C8.6636 22.7115 8.60039 22.5589 8.60039 22.3998V19.9998ZM16.4004 19.3998C16.2413 19.3998 16.0886 19.463 15.9761 19.5755C15.8636 19.6881 15.8004 19.8407 15.8004 19.9998C15.8004 20.1589 15.8636 20.3115 15.9761 20.4241C16.0886 20.5366 16.2413 20.5998 16.4004 20.5998H26.0004C26.1595 20.5998 26.3121 20.5366 26.4247 20.4241C26.5372 20.3115 26.6004 20.1589 26.6004 19.9998C26.6004 19.8407 26.5372 19.6881 26.4247 19.5755C26.3121 19.463 26.1595 19.3998 26.0004 19.3998H16.4004ZM16.4004 21.7998C16.2413 21.7998 16.0886 21.863 15.9761 21.9755C15.8636 22.0881 15.8004 22.2407 15.8004 22.3998C15.8004 22.5589 15.8636 22.7115 15.9761 22.8241C16.0886 22.9366 16.2413 22.9998 16.4004 22.9998H23.6004C23.7595 22.9998 23.9121 22.9366 24.0247 22.8241C24.1372 22.7115 24.2004 22.5589 24.2004 22.3998C24.2004 22.2407 24.1372 22.0881 24.0247 21.9755C23.9121 21.863 23.7595 21.7998 23.6004 21.7998H16.4004Z"
                fill="#2A3F57"/>
              <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" stroke="#2A3F57"/>
            </svg>
          </div>
          <div class="type-switcher__item" :class="{ show: type == 'cards' }" @click="type = 'cards'">
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M15.5738 8.86902C14.9918 8.3126 14.2024 8 13.3793 8H11.1034C10.2804 8 9.49099 8.3126 8.90898 8.86902C8.32697 9.42545 8 10.1801 8 10.967V13.5385C8 14.3254 8.32697 15.08 8.90898 15.6365C9.49099 16.1929 10.2804 16.5055 11.1034 16.5055H13.3793C14.2024 16.5055 14.9918 16.1929 15.5738 15.6365C16.1558 15.08 16.4828 14.3254 16.4828 13.5385V10.967C16.4828 10.1801 16.1558 9.42545 15.5738 8.86902ZM9.24138 13.5385V10.967C9.24138 10.4949 9.43756 10.0421 9.78677 9.70823C10.136 9.37437 10.6096 9.18681 11.1034 9.18681H13.3793C13.8732 9.18681 14.3468 9.37437 14.696 9.70823C15.0452 10.0421 15.2414 10.4949 15.2414 10.967V13.5385C15.2414 14.0106 15.0452 14.4634 14.696 14.7973C14.3468 15.1311 13.8732 15.3187 13.3793 15.3187H11.1034C10.6096 15.3187 10.136 15.1311 9.78677 14.7973C9.43756 14.4634 9.24138 14.0106 9.24138 13.5385Z"
                    fill="#2A3F57"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M25.091 8.86902C24.509 8.3126 23.7196 8 22.8966 8H20.6207C19.7976 8 19.0082 8.3126 18.4262 8.86902C17.8442 9.42545 17.5172 10.1801 17.5172 10.967V13.5385C17.5172 14.3254 17.8442 15.08 18.4262 15.6365C19.0082 16.1929 19.7976 16.5055 20.6207 16.5055H22.8966C23.7196 16.5055 24.509 16.1929 25.091 15.6365C25.673 15.08 26 14.3254 26 13.5385V10.967C26 10.1801 25.673 9.42545 25.091 8.86902ZM18.7586 13.5385V10.967C18.7586 10.4949 18.9548 10.0421 19.304 9.70823C19.6532 9.37437 20.1268 9.18681 20.6207 9.18681H22.8966C23.3904 9.18681 23.864 9.37437 24.2132 9.70823C24.5624 10.0421 24.7586 10.4949 24.7586 10.967V13.5385C24.7586 14.0106 24.5624 14.4634 24.2132 14.7973C23.864 15.1311 23.3904 15.3187 22.8966 15.3187H20.6207C20.1268 15.3187 19.6532 15.1311 19.304 14.7973C18.9548 14.4634 18.7586 14.0106 18.7586 13.5385Z"
                    fill="#2A3F57"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M15.5738 18.3635C14.9918 17.8071 14.2024 17.4945 13.3793 17.4945H11.1034C10.2804 17.4945 9.49099 17.8071 8.90898 18.3635C8.32697 18.92 8 19.6746 8 20.4615V23.033C8 23.8199 8.32697 24.5745 8.90898 25.131C9.49099 25.6874 10.2804 26 11.1034 26H13.3793C14.2024 26 14.9918 25.6874 15.5738 25.131C16.1558 24.5745 16.4828 23.8199 16.4828 23.033V20.4615C16.4828 19.6746 16.1558 18.92 15.5738 18.3635ZM9.24138 23.033V20.4615C9.24138 19.9894 9.43756 19.5366 9.78677 19.2027C10.136 18.8689 10.6096 18.6813 11.1034 18.6813H13.3793C13.8732 18.6813 14.3468 18.8689 14.696 19.2027C15.0452 19.5366 15.2414 19.9894 15.2414 20.4615V23.033C15.2414 23.5051 15.0452 23.9579 14.696 24.2918C14.3468 24.6256 13.8732 24.8132 13.3793 24.8132H11.1034C10.6096 24.8132 10.136 24.6256 9.78677 24.2918C9.43756 23.9579 9.24138 23.5051 9.24138 23.033Z"
                    fill="#2A3F57"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M25.091 18.3635C24.509 17.8071 23.7196 17.4945 22.8966 17.4945H20.6207C19.7976 17.4945 19.0082 17.8071 18.4262 18.3635C17.8442 18.92 17.5172 19.6746 17.5172 20.4615V23.033C17.5172 23.8199 17.8442 24.5745 18.4262 25.131C19.0082 25.6874 19.7976 26 20.6207 26H22.8966C23.7196 26 24.509 25.6874 25.091 25.131C25.673 24.5745 26 23.8199 26 23.033V20.4615C26 19.6746 25.673 18.92 25.091 18.3635ZM18.7586 23.033V20.4615C18.7586 19.9894 18.9548 19.5366 19.304 19.2027C19.6532 18.8689 20.1268 18.6813 20.6207 18.6813H22.8966C23.3904 18.6813 23.864 18.8689 24.2132 19.2027C24.5624 19.5366 24.7586 19.9894 24.7586 20.4615V23.033C24.7586 23.5051 24.5624 23.9579 24.2132 24.2918C23.864 24.6256 23.3904 24.8132 22.8966 24.8132H20.6207C20.1268 24.8132 19.6532 24.6256 19.304 24.2918C18.9548 23.9579 18.7586 23.5051 18.7586 23.033Z"
                    fill="#2A3F57"/>
              <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" stroke="#2A3F57"/>
            </svg>
          </div>
          <div class="type-switcher__item type-switcher__item--settings" @click="settingsModal=true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="path-1-inside-1_1733_6915" fill="white">
                <path
                  d="M2.29162 8.85988C2.73501 7.49078 3.4634 6.23113 4.42882 5.16388C4.50861 5.0757 4.61281 5.01322 4.72819 4.98437C4.84356 4.95553 4.96491 4.96162 5.07682 5.00188L7.37842 5.82508C7.54227 5.88359 7.71688 5.90577 7.89016 5.89008C8.06343 5.8744 8.23122 5.82122 8.3819 5.73423C8.53258 5.64725 8.66254 5.52854 8.76278 5.38634C8.86302 5.24413 8.93114 5.08183 8.96242 4.91068L9.40042 2.50348C9.42163 2.3863 9.47723 2.27808 9.56014 2.1926C9.64306 2.10712 9.74953 2.04825 9.86602 2.02348C11.2722 1.72394 12.7258 1.72394 14.132 2.02348C14.2485 2.04825 14.355 2.10712 14.4379 2.1926C14.5208 2.27808 14.5764 2.3863 14.5976 2.50348L15.0368 4.91068C15.0681 5.08183 15.1362 5.24413 15.2364 5.38634C15.3367 5.52854 15.4666 5.64725 15.6173 5.73423C15.768 5.82122 15.9358 5.8744 16.1091 5.89008C16.2823 5.90577 16.457 5.88359 16.6208 5.82508L18.9236 5.00188C19.0355 4.96202 19.1566 4.95626 19.2718 4.98531C19.3869 5.01436 19.4909 5.07693 19.5704 5.16508C20.5353 6.23209 21.2632 7.4913 21.7064 8.85988C21.743 8.97293 21.7452 9.09429 21.7127 9.20858C21.6802 9.32288 21.6146 9.42495 21.524 9.50188L19.658 11.0859C19.5255 11.1985 19.419 11.3387 19.346 11.4965C19.2729 11.6544 19.2351 11.8263 19.2351 12.0003C19.2351 12.1742 19.2729 12.3461 19.346 12.504C19.419 12.6619 19.5255 12.802 19.658 12.9147L21.524 14.4987C21.6146 14.5756 21.6802 14.6777 21.7127 14.792C21.7452 14.9063 21.743 15.0276 21.7064 15.1407C21.2634 16.5097 20.5354 17.7693 19.5704 18.8367C19.4906 18.9249 19.3864 18.9873 19.271 19.0162C19.1557 19.045 19.0343 19.0389 18.9224 18.9987L16.6208 18.1755C16.457 18.117 16.2823 18.0948 16.1091 18.1105C15.9358 18.1262 15.768 18.1793 15.6173 18.2663C15.4666 18.3533 15.3367 18.472 15.2364 18.6142C15.1362 18.7564 15.0681 18.9187 15.0368 19.0899L14.5964 21.4983C14.5751 21.6151 14.5195 21.7229 14.4369 21.8082C14.3542 21.8934 14.2481 21.9522 14.132 21.9771C12.7258 22.2767 11.2722 22.2767 9.86602 21.9771C9.74953 21.9523 9.64306 21.8934 9.56014 21.808C9.47723 21.7225 9.42163 21.6143 9.40042 21.4971L8.96242 19.0899C8.93114 18.9187 8.86302 18.7564 8.76278 18.6142C8.66254 18.472 8.53258 18.3533 8.3819 18.2663C8.23122 18.1793 8.06343 18.1262 7.89016 18.1105C7.71688 18.0948 7.54227 18.117 7.37842 18.1755L5.07562 18.9987C4.96376 19.0385 4.84258 19.0443 4.72744 19.0152C4.61231 18.9862 4.50838 18.9236 4.42882 18.8355C3.46395 17.7685 2.73598 16.5093 2.29282 15.1407C2.25623 15.0276 2.25404 14.9063 2.28651 14.792C2.31899 14.6777 2.38466 14.5756 2.47522 14.4987L4.34122 12.9147C4.47377 12.802 4.58025 12.6619 4.65328 12.504C4.7263 12.3461 4.76412 12.1742 4.76412 12.0003C4.76412 11.8263 4.7263 11.6544 4.65328 11.4965C4.58025 11.3387 4.47377 11.1985 4.34122 11.0859L2.47522 9.50188C2.38466 9.42495 2.31899 9.32288 2.28651 9.20858C2.25404 9.09429 2.25623 8.97293 2.29282 8.85988H2.29162ZM3.56482 8.85268L5.11761 10.1703C5.38314 10.3956 5.59646 10.676 5.74276 10.992C5.88906 11.308 5.96484 11.652 5.96484 12.0003C5.96484 12.3485 5.88906 12.6926 5.74276 13.0086C5.59646 13.3246 5.38314 13.605 5.11761 13.8303L3.56482 15.1479C3.91522 16.0863 4.42162 16.9599 5.05882 17.7303L6.97401 17.0463C7.3018 16.9293 7.65112 16.8849 7.99774 16.9164C8.34436 16.9478 8.68 17.0543 8.98137 17.2284C9.28275 17.4025 9.54266 17.64 9.74307 17.9246C9.94349 18.2091 10.0796 18.5339 10.142 18.8763L10.508 20.8779C11.4952 21.0425 12.5028 21.0425 13.49 20.8779L13.856 18.8739C13.9186 18.5316 14.0548 18.207 14.2553 17.9226C14.4558 17.6382 14.7157 17.4007 15.017 17.2268C15.3184 17.0528 15.654 16.9464 16.0005 16.9151C16.3471 16.8837 16.6963 16.9281 17.024 17.0451L18.9404 17.7303C19.5788 16.9587 20.0837 16.0859 20.4344 15.1479L18.8816 13.8303C18.6157 13.6052 18.4021 13.3249 18.2555 13.0089C18.109 12.6928 18.0331 12.3486 18.0331 12.0003C18.0331 11.6519 18.109 11.3077 18.2555 10.9917C18.4021 10.6757 18.6157 10.3954 18.8816 10.1703L20.4344 8.85268C20.0838 7.91466 19.5788 7.04184 18.9404 6.27028L17.0252 6.95428C16.6975 7.0713 16.3483 7.11566 16.0017 7.08428C15.6552 7.05291 15.3196 6.94656 15.0182 6.77259C14.7169 6.59862 14.457 6.36121 14.2565 6.0768C14.056 5.79238 13.9198 5.46778 13.8572 5.12548L13.49 3.12268C12.5028 2.95809 11.4952 2.95809 10.508 3.12268L10.1432 5.12548C10.0808 5.46789 9.94469 5.79262 9.74427 6.07718C9.54386 6.36173 9.28395 6.59928 8.98257 6.77338C8.6812 6.94747 8.34556 7.05393 7.99894 7.08537C7.65232 7.11682 7.303 7.07249 6.97522 6.95548L5.05882 6.27028C4.42045 7.04185 3.9155 7.91467 3.56482 8.85268ZM8.99962 12.0003C8.99962 11.2046 9.31569 10.4416 9.87829 9.87896C10.4409 9.31635 11.204 9.00028 11.9996 9.00028C12.7953 9.00028 13.5583 9.31635 14.1209 9.87896C14.6835 10.4416 14.9996 11.2046 14.9996 12.0003C14.9996 12.7959 14.6835 13.559 14.1209 14.1216C13.5583 14.6842 12.7953 15.0003 11.9996 15.0003C11.204 15.0003 10.4409 14.6842 9.87829 14.1216C9.31569 13.559 8.99962 12.7959 8.99962 12.0003ZM10.1996 12.0003C10.1996 12.4777 10.3893 12.9355 10.7268 13.2731C11.0644 13.6106 11.5222 13.8003 11.9996 13.8003C12.477 13.8003 12.9348 13.6106 13.2724 13.2731C13.61 12.9355 13.7996 12.4777 13.7996 12.0003C13.7996 11.5229 13.61 11.0651 13.2724 10.7275C12.9348 10.3899 12.477 10.2003 11.9996 10.2003C11.5222 10.2003 11.0644 10.3899 10.7268 10.7275C10.3893 11.0651 10.1996 11.5229 10.1996 12.0003Z"/>
              </mask>
              <path
                d="M2.29162 8.85988C2.73501 7.49078 3.4634 6.23113 4.42882 5.16388C4.50861 5.0757 4.61281 5.01322 4.72819 4.98437C4.84356 4.95553 4.96491 4.96162 5.07682 5.00188L7.37842 5.82508C7.54227 5.88359 7.71688 5.90577 7.89016 5.89008C8.06343 5.8744 8.23122 5.82122 8.3819 5.73423C8.53258 5.64725 8.66254 5.52854 8.76278 5.38634C8.86302 5.24413 8.93114 5.08183 8.96242 4.91068L9.40042 2.50348C9.42163 2.3863 9.47723 2.27808 9.56014 2.1926C9.64306 2.10712 9.74953 2.04825 9.86602 2.02348C11.2722 1.72394 12.7258 1.72394 14.132 2.02348C14.2485 2.04825 14.355 2.10712 14.4379 2.1926C14.5208 2.27808 14.5764 2.3863 14.5976 2.50348L15.0368 4.91068C15.0681 5.08183 15.1362 5.24413 15.2364 5.38634C15.3367 5.52854 15.4666 5.64725 15.6173 5.73423C15.768 5.82122 15.9358 5.8744 16.1091 5.89008C16.2823 5.90577 16.457 5.88359 16.6208 5.82508L18.9236 5.00188C19.0355 4.96202 19.1566 4.95626 19.2718 4.98531C19.3869 5.01436 19.4909 5.07693 19.5704 5.16508C20.5353 6.23209 21.2632 7.4913 21.7064 8.85988C21.743 8.97293 21.7452 9.09429 21.7127 9.20858C21.6802 9.32288 21.6146 9.42495 21.524 9.50188L19.658 11.0859C19.5255 11.1985 19.419 11.3387 19.346 11.4965C19.2729 11.6544 19.2351 11.8263 19.2351 12.0003C19.2351 12.1742 19.2729 12.3461 19.346 12.504C19.419 12.6619 19.5255 12.802 19.658 12.9147L21.524 14.4987C21.6146 14.5756 21.6802 14.6777 21.7127 14.792C21.7452 14.9063 21.743 15.0276 21.7064 15.1407C21.2634 16.5097 20.5354 17.7693 19.5704 18.8367C19.4906 18.9249 19.3864 18.9873 19.271 19.0162C19.1557 19.045 19.0343 19.0389 18.9224 18.9987L16.6208 18.1755C16.457 18.117 16.2823 18.0948 16.1091 18.1105C15.9358 18.1262 15.768 18.1793 15.6173 18.2663C15.4666 18.3533 15.3367 18.472 15.2364 18.6142C15.1362 18.7564 15.0681 18.9187 15.0368 19.0899L14.5964 21.4983C14.5751 21.6151 14.5195 21.7229 14.4369 21.8082C14.3542 21.8934 14.2481 21.9522 14.132 21.9771C12.7258 22.2767 11.2722 22.2767 9.86602 21.9771C9.74953 21.9523 9.64306 21.8934 9.56014 21.808C9.47723 21.7225 9.42163 21.6143 9.40042 21.4971L8.96242 19.0899C8.93114 18.9187 8.86302 18.7564 8.76278 18.6142C8.66254 18.472 8.53258 18.3533 8.3819 18.2663C8.23122 18.1793 8.06343 18.1262 7.89016 18.1105C7.71688 18.0948 7.54227 18.117 7.37842 18.1755L5.07562 18.9987C4.96376 19.0385 4.84258 19.0443 4.72744 19.0152C4.61231 18.9862 4.50838 18.9236 4.42882 18.8355C3.46395 17.7685 2.73598 16.5093 2.29282 15.1407C2.25623 15.0276 2.25404 14.9063 2.28651 14.792C2.31899 14.6777 2.38466 14.5756 2.47522 14.4987L4.34122 12.9147C4.47377 12.802 4.58025 12.6619 4.65328 12.504C4.7263 12.3461 4.76412 12.1742 4.76412 12.0003C4.76412 11.8263 4.7263 11.6544 4.65328 11.4965C4.58025 11.3387 4.47377 11.1985 4.34122 11.0859L2.47522 9.50188C2.38466 9.42495 2.31899 9.32288 2.28651 9.20858C2.25404 9.09429 2.25623 8.97293 2.29282 8.85988H2.29162ZM3.56482 8.85268L5.11761 10.1703C5.38314 10.3956 5.59646 10.676 5.74276 10.992C5.88906 11.308 5.96484 11.652 5.96484 12.0003C5.96484 12.3485 5.88906 12.6926 5.74276 13.0086C5.59646 13.3246 5.38314 13.605 5.11761 13.8303L3.56482 15.1479C3.91522 16.0863 4.42162 16.9599 5.05882 17.7303L6.97401 17.0463C7.3018 16.9293 7.65112 16.8849 7.99774 16.9164C8.34436 16.9478 8.68 17.0543 8.98137 17.2284C9.28275 17.4025 9.54266 17.64 9.74307 17.9246C9.94349 18.2091 10.0796 18.5339 10.142 18.8763L10.508 20.8779C11.4952 21.0425 12.5028 21.0425 13.49 20.8779L13.856 18.8739C13.9186 18.5316 14.0548 18.207 14.2553 17.9226C14.4558 17.6382 14.7157 17.4007 15.017 17.2268C15.3184 17.0528 15.654 16.9464 16.0005 16.9151C16.3471 16.8837 16.6963 16.9281 17.024 17.0451L18.9404 17.7303C19.5788 16.9587 20.0837 16.0859 20.4344 15.1479L18.8816 13.8303C18.6157 13.6052 18.4021 13.3249 18.2555 13.0089C18.109 12.6928 18.0331 12.3486 18.0331 12.0003C18.0331 11.6519 18.109 11.3077 18.2555 10.9917C18.4021 10.6757 18.6157 10.3954 18.8816 10.1703L20.4344 8.85268C20.0838 7.91466 19.5788 7.04184 18.9404 6.27028L17.0252 6.95428C16.6975 7.0713 16.3483 7.11566 16.0017 7.08428C15.6552 7.05291 15.3196 6.94656 15.0182 6.77259C14.7169 6.59862 14.457 6.36121 14.2565 6.0768C14.056 5.79238 13.9198 5.46778 13.8572 5.12548L13.49 3.12268C12.5028 2.95809 11.4952 2.95809 10.508 3.12268L10.1432 5.12548C10.0808 5.46789 9.94469 5.79262 9.74427 6.07718C9.54386 6.36173 9.28395 6.59928 8.98257 6.77338C8.6812 6.94747 8.34556 7.05393 7.99894 7.08537C7.65232 7.11682 7.303 7.07249 6.97522 6.95548L5.05882 6.27028C4.42045 7.04185 3.9155 7.91467 3.56482 8.85268ZM8.99962 12.0003C8.99962 11.2046 9.31569 10.4416 9.87829 9.87896C10.4409 9.31635 11.204 9.00028 11.9996 9.00028C12.7953 9.00028 13.5583 9.31635 14.1209 9.87896C14.6835 10.4416 14.9996 11.2046 14.9996 12.0003C14.9996 12.7959 14.6835 13.559 14.1209 14.1216C13.5583 14.6842 12.7953 15.0003 11.9996 15.0003C11.204 15.0003 10.4409 14.6842 9.87829 14.1216C9.31569 13.559 8.99962 12.7959 8.99962 12.0003ZM10.1996 12.0003C10.1996 12.4777 10.3893 12.9355 10.7268 13.2731C11.0644 13.6106 11.5222 13.8003 11.9996 13.8003C12.477 13.8003 12.9348 13.6106 13.2724 13.2731C13.61 12.9355 13.7996 12.4777 13.7996 12.0003C13.7996 11.5229 13.61 11.0651 13.2724 10.7275C12.9348 10.3899 12.477 10.2003 11.9996 10.2003C11.5222 10.2003 11.0644 10.3899 10.7268 10.7275C10.3893 11.0651 10.1996 11.5229 10.1996 12.0003Z"
                fill="#E1EBF8" stroke="#E1EBF8" stroke-width="2" mask="url(#path-1-inside-1_1733_6915)"/>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <table class="main-table">
      <thead v-if="type == 'rows'" class="timing-wrap timing__head">
      <draggable v-model="headers" tag="tr" @change="saveSettings">
        <template v-for="header in headers">
          <td class="sortable" @click="set_sort(header.key)" :key="header.key" scope="col"
              v-if="showHeaders[header.key]">
            {{ $vuetify.lang.t('$vuetify.' + header.name) }}
            <v-icon class="sorts__icon" v-if="sort.includes(header.key)" :class="{reverse: sort[0] == '-'}">
              mdi-arrow-up
            </v-icon>
          </td>
        </template>
        <td></td>
      </draggable>
      </thead>
      <tbody :class="{ 'cards ': type == 'cards' }">
      <tr class="man-wrap" :class="{ rows__single: type == 'rows',  'timing-wrap': type == 'rows'}"
          v-for="item in products"
          :ref="'item'+item.id"
          :key="item.id" @click="truncate(item.id)">
        <div class="cards__single" v-if="type == 'cards'">
          <a
            :href="item.link" target="_blank"
             class="link-not-like photo photo-human"
          >
            <img v-if="item.photo" :src="$media_url + item.photo" loading="lazy" alt="photo"/>
            <img v-else :src="$media_url + 'images/nophoto.png'" loading="lazy" alt="photo"/>
          </a>
          <div class="cards__main-info">
            <h2>
              <a class="link-not-like" :href="item.link" target="_blank">{{
                  item.name[$vuetify.lang.current] ? item.name[$vuetify.lang.current] : item.name['eng']
                }}
              </a>
            </h2>
            <h3 class="bolder">
              {{ item.price }} €
            </h3>
            <div class="main-info__description">
              <div class="timing-pre__wrap cp" :class="{'truncate-text': item.id!==notruncate}"
                   :style="'max-height: 100%; min-height: 60px; height:' + (item.id!==notruncate ? '60px' : (inHeight+'px'))">
                <pre :id="'item-card'+item.id">{{ item.description }}</pre>
              </div>
            </div>
          </div>
          <div class="cards__buttons">
            <button v-if="permissions.edit.indexOf('Каталог') != -1" class="btn-icon btn-action"
                    @click="action='edit';newProduct=item; productCreateOpen()">
              <edit-icon/>
            </button>
            <button v-if="permissions.edit.indexOf('Каталог') != -1" class="btn-icon btn-action"
                    @click="newProduct=item; confirm_archive_modal=true">
              <archive-icon/>
            </button>
            <button v-if="permissions.edit.indexOf('Каталог') != -1" class="btn-icon btn-action"
                    @click="confirmOpen(item.id, 'product')">
              <delete-icon/>
            </button>
          </div>
          <ul class="cards__info">
            <li>
              <span>
              <svg width="24" height="24" focusable="false"
                   aria-hidden="true" viewBox="0 0 24 24" data-testid="AssignmentOutlinedIcon"><path
                d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"></path></svg>
              </span>
              <span>{{ item.product_code }}</span>
            </li>
            <li>
              <span>
              <svg width="24" height="24" focusable="false"
                   aria-hidden="true" viewBox="0 0 24 24" data-testid="AssignmentOutlinedIcon"><path
                d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"></path></svg>
              </span>
              <span>{{ item.ean_code }}</span>
            </li>
          </ul>
        </div>
        <template v-if="type == 'rows'">
          <template v-for="(header) in headers">
            <template v-if="showHeaders[header.key]">
              <td :key="header.key" v-if="header.key != 'description'">
                <template v-if="header.name == 'name2'">
                  <a class="link-not-like flex" :href="item.link" target="_blank">
                    <div class="avatar">
                      <img v-if="item.photo" :src="$media_url + item.photo" loading="lazy" alt=""/>
                    </div>
                    <span>{{
                        item[header.key][$vuetify.lang.current] ? item[header.key][$vuetify.lang.current] : item[header.key]['eng']
                      }}</span>
                  </a>
                </template>
                <template v-else-if="header.name == 'accounting.card.price'">
                  {{ item[header.key] }} €
                </template>
                <template v-else>
                  {{ item[header.key] }}
                </template>
              </td>
              <td v-else :key="header.key" class="timing__work">
                <div class="timing-pre__wrap" :class="{'truncate-text': item.id!==notruncate}"
                     :style="'max-height: 100%; min-height: 60px; height:' + (item.id!==notruncate ? '60px' : (inHeight+'px'))">
                  <pre :id="'item'+item.id">{{ item[header.key] }}</pre>
                </div>
              </td>
            </template>
          </template>
          <td class="rows__dot-menu" v-if="permissions.edit.indexOf('Каталог') != -1">
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark icon v-bind="attrs" v-on="on">
                  <svg
                    v-bind="attrs"
                    v-on="on"
                    width="20"
                    height="5"
                    viewBox="0 0 20 5"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="2" cy="2.5" r="2" fill="#2C1521"/>
                    <circle cx="10" cy="2.5" r="2" fill="#2C1521"/>
                    <circle cx="18" cy="2.5" r="2" fill="#2C1521"/>
                  </svg>
                </v-btn>
              </template>
              <div class="rows__dot-menu-content">
                <div class="btn-wrap"
                     @click="action='edit';newProduct=item; productCreateOpen()">
                  {{ $vuetify.lang.t('$vuetify.edit') }}
                  <button class="btn-icon btn-action">
                    <edit-icon></edit-icon>
                  </button>
                </div>
                <div class="btn-wrap"
                     @click="confirmOpen(item.id, 'product')">
                  {{ $vuetify.lang.t('$vuetify.delete') }}
                  <button class="btn-icon btn-action">
                    <delete-icon></delete-icon>
                  </button>
                </div>
                <div class="btn-wrap" @click="newProduct=item; confirm_archive_modal=true">
                  <span v-if="item.active">{{ $vuetify.lang.t('$vuetify.toArchive') }}</span>
                  <span v-else>{{ $vuetify.lang.t('$vuetify.deleteArchive') }}</span>
                  <button class="btn-icon btn-action">
                    <picture>
                      <archive-icon/>
                    </picture>
                  </button>
                </div>
              </div>
            </v-menu>
          </td>
        </template>
      </tr>
      </tbody>
    </table>
    <div class="page-footer">
      <per-page-select v-model="perPage"></per-page-select>
      <v-pagination
        v-model="page"
        :length="length"
        @input="loadData"
      ></v-pagination>
    </div>

    <v-dialog v-model="shopModal">
      <div class="modal modal-big">
        <table class="modal-table">
          <thead>
          <tr>
            <th> {{ $vuetify.lang.t('$vuetify.name2') }}</th>
            <th> {{ $vuetify.lang.t('$vuetify.address') }}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <template v-for="shop in shops">
            <tr :key="shop.id" class="">
              <td>{{ shop.name }}</td>
              <td>{{ shop.address }}</td>
              <td class="rows__dot-menu">
                <v-menu bottom right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-bind="attrs" v-on="on">
                      <svg
                        v-bind="attrs"
                        v-on="on"
                        width="20"
                        height="5"
                        viewBox="0 0 20 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="2" cy="2.5" r="2" fill="#2C1521"/>
                        <circle cx="10" cy="2.5" r="2" fill="#2C1521"/>
                        <circle cx="18" cy="2.5" r="2" fill="#2C1521"/>
                      </svg>
                    </v-btn>
                  </template>
                  <div class="rows__dot-menu-content">
                    <div class="btn-wrap"
                         @click="action='edit';newShop=shop">
                      {{ $vuetify.lang.t('$vuetify.edit') }}
                      <button class="btn-icon btn-action">
                        <edit-icon></edit-icon>
                      </button>
                    </div>
                    <div class="btn-wrap"
                         @click="confirmOpen(shop.id, 'shop')">
                      {{ $vuetify.lang.t('$vuetify.delete') }}
                      <button class="btn-icon btn-action">
                        <delete-icon></delete-icon>
                      </button>
                    </div>
                  </div>
                </v-menu>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
        <v-form ref="formShop" @submit.prevent="">
          <div class="form__row">
            <v-text-field v-model="newShop.name" :label="$vuetify.lang.t('$vuetify.name2')"
                          :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newShop.address" :label="$vuetify.lang.t('$vuetify.address')"
                          :rules="[$rules.required]"></v-text-field>
          </div>
          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <button class="btn btn-primary" @click="addShop">
              <span v-if="action == 'add'">{{ $vuetify.lang.t('$vuetify.add') }}</span>
              <span v-else-if="action == 'edit'">{{ $vuetify.lang.t('$vuetify.edit') }}</span>
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>
    <v-dialog v-model="sellerModal">
      <div class="modal modal-big">
        <table class="modal-table">
          <thead>
          <tr>
            <th> {{ $vuetify.lang.t('$vuetify.surnameName') }}</th>
            <th> {{ $vuetify.lang.t('$vuetify.shop') }}</th>
            <th> {{ $vuetify.lang.t('$vuetify.connection') }}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <template v-for="seller in sellers">
            <tr :key="seller.id" class="">
              <td>{{ seller.first_name }} {{ seller.last_name }}</td>
              <td>{{ seller.shop_name }}</td>
              <td class="flex flex-column no-gap align-start">
                <a :href="'tel:' + seller.phone.replace(/\D/g, '') ">{{ seller.phone }}</a>
                <a :href="'mailto:' + seller.email">{{ seller.email }}</a>
              </td>
              <td class="rows__dot-menu">
                <v-menu bottom right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-bind="attrs" v-on="on">
                      <svg
                        v-bind="attrs"
                        v-on="on"
                        width="20"
                        height="5"
                        viewBox="0 0 20 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="2" cy="2.5" r="2" fill="#2C1521"/>
                        <circle cx="10" cy="2.5" r="2" fill="#2C1521"/>
                        <circle cx="18" cy="2.5" r="2" fill="#2C1521"/>
                      </svg>
                    </v-btn>
                  </template>
                  <div class="rows__dot-menu-content">
                    <div class="btn-wrap"
                         @click="action='edit'; newSeller=seller">
                      {{ $vuetify.lang.t('$vuetify.edit') }}
                      <button class="btn-icon btn-action">
                        <edit-icon></edit-icon>
                      </button>
                    </div>
                    <div class="btn-wrap"
                         @click="confirmOpen(seller.id, 'seller')">
                      {{ $vuetify.lang.t('$vuetify.delete') }}
                      <button class="btn-icon btn-action">
                        <delete-icon></delete-icon>
                      </button>
                    </div>
                  </div>
                </v-menu>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
        <v-form ref="formSeller" @submit.prevent="">
          <v-autocomplete v-model="newSeller.shop" :items="shops" :label="$vuetify.lang.t('$vuetify.shop')"
                          item-text="name" item-value="id" attach
                          :menu-props="{
          bottom: true,
          offsetY: true,
          maxHeight: width<1024 ? 200 : 800,
          contentClass: 'select-menu',
          }"
                          :rules="[$rules.required]"></v-autocomplete>

          <v-text-field v-model="newSeller.first_name"
                        :label="$vuetify.lang.t('$vuetify.name')" :rules="[$rules.required]"></v-text-field>

          <v-text-field v-model="newSeller.last_name"
                        :label="$vuetify.lang.t('$vuetify.surname')" :rules="[$rules.required]"></v-text-field>

          <v-text-field v-model="newSeller.phone" :label="$vuetify.lang.t('$vuetify.phone')"
                        :rules="[$rules.required]"></v-text-field>

          <v-text-field v-model="newSeller.email" label="Email"
                        :rules="[$rules.required, $rules.email, $rules.notSpaces]"></v-text-field>

          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <button class="btn btn-primary" @click="addSeller">
              <span v-if="action == 'add'">{{ $vuetify.lang.t('$vuetify.add') }}</span>
              <span v-else-if="action == 'edit'">{{ $vuetify.lang.t('$vuetify.edit') }}</span>
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>
    <v-dialog v-model="productCreateModal">
      <div class="modal modal-big">
        <div class="h1">
          <span v-if="action == 'add'">{{ $vuetify.lang.t('$vuetify.add') }}</span>
          <span v-else-if="action == 'edit'">{{ $vuetify.lang.t('$vuetify.edit') }}</span>
        </div>
        <v-form ref="formProduct" @submit.prevent="">
          <div class="form__row align-baseline">
            <v-autocomplete v-model="newProduct.category"
                            :items="categories" return-object :item-text="$vuetify.lang.current"
                            :label="$vuetify.lang.t('$vuetify.accounting.card.category')" outlined attach
                            :rules="[$rules.required]"
                            :menu-props="{
          bottom: true,
          offsetY: true,
          maxHeight: width<1024 ? 200 : 800,
          contentClass: 'select-menu',
          }"></v-autocomplete>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <button class="btn-icon btn-action" @click="categoryCreateOpen"
                        v-bind="attrs"
                        v-on="on">
                  +
                </button>
              </template>
              <span>{{ $vuetify.lang.t("$vuetify.addCategory") }}</span>
            </v-tooltip>
          </div>
          <h2>{{ $vuetify.lang.t('$vuetify.name2') }}</h2>
          <template v-for="lang in Object.keys($vuetify.lang.locales)">
            <v-text-field v-if="['eng', 'rus'].includes(lang)" :key=lang
                          v-model="newProduct.name[lang]"
                          :label="$vuetify.lang.t('$vuetify.settings.languages.'+lang)" outlined
                          :rules="[$rules.required]"></v-text-field>
            <v-text-field v-else-if="!['en', 'ru'].includes(lang)" :key=lang v-model="newProduct.name[lang]"
                          :label="$vuetify.lang.t('$vuetify.settings.languages.'+lang)" outlined></v-text-field>
          </template>

          <v-text-field v-model="newProduct.product_code" :label="$vuetify.lang.t('$vuetify.productCode')"
                        :rules="[$rules.required]" outlined></v-text-field>

          <v-text-field v-model="newProduct.ean_code" :label="$vuetify.lang.t('$vuetify.eanCode')"
                        :rules="[$rules.required]" outlined></v-text-field>

          <v-textarea v-model="newProduct.description" :label="$vuetify.lang.t('$vuetify.description')"
                      :rules="[$rules.required]" outlined></v-textarea>

          <v-text-field v-model="newProduct.link" :label="$vuetify.lang.t('$vuetify.link')"
                        :rules="[$rules.required]" outlined></v-text-field>

          <v-text-field v-model="newProduct.price" :label="$vuetify.lang.t('$vuetify.accounting.card.price')"
                        :rules="[$rules.required, $rules.positiveNumbers]" outlined></v-text-field>
          <v-combobox class="custom" v-model="newProduct.measurement"
                      :label="$vuetify.lang.t('$vuetify.wages.measurement')"
                      :items="measurements" item-text="name" item-value="value" outlined attach
                      :menu-props="{
                          bottom: true,
                          offsetY: true,
                          maxHeight: width<1024 ? 200 : 800,
                          contentClass: 'select-menu',
                        }">
            <template v-slot:item="{ item }">
              {{
                $vuetify.lang.t('$vuetify.measurements.' + item) ? $vuetify.lang.t('$vuetify.measurements.' + item) : item
              }}
            </template>
            <template v-slot:selection="{ item}">
                  <span>{{
                      $vuetify.lang.t('$vuetify.measurements.' + item) ? $vuetify.lang.t('$vuetify.measurements.' + item) : item
                    }}</span>
            </template>
          </v-combobox>

          <v-autocomplete v-model="newProduct.shop" :items="shops" :label="$vuetify.lang.t('$vuetify.shop')"
                          item-text="name" item-value="id" attach outlined
                          :menu-props="{
          bottom: true,
          offsetY: true,
          maxHeight: width<1024 ? 200 : 800,
          contentClass: 'select-menu',
          }"></v-autocomplete>
          <v-file-input class="file-input" v-model="photo" accept=".jpg, .png, .jpeg"
                        :placeholder="newProduct.photo ? $vuetify.lang.t('$vuetify.changeImg') : $vuetify.lang.t('$vuetify.uploadImg')"
                        prepend-icon="$photo" :rules="[$rules.fileSize]"></v-file-input>

          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <button class="btn btn-secondary" @click="productCreateClose">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </button>
            <button class="btn btn-primary" @click="uploadPhoto">
              <span v-if="action == 'add'">{{ $vuetify.lang.t('$vuetify.add') }}</span>
              <span v-else-if="action == 'edit'">{{ $vuetify.lang.t('$vuetify.edit') }}</span>
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>
    <v-dialog v-model="categoryCreateModal">
      <div class="modal">
        <div class="h1">{{ $vuetify.lang.t('$vuetify.addCategory') }}</div>
        <v-form ref="category" @submit.prevent="">
          <template v-for="lang in Object.keys($vuetify.lang.locales)">
            <v-text-field v-if="['eng', 'rus'].includes(lang)" :key=lang
                          v-model="newCategory[lang]"
                          :label="$vuetify.lang.t('$vuetify.settings.languages.'+lang)" outlined
                          :rules="[$rules.required]"></v-text-field>
            <v-text-field v-else-if="!['en', 'ru'].includes(lang)" :key=lang v-model="newCategory[lang]"
                          :label="$vuetify.lang.t('$vuetify.settings.languages.'+lang)" outlined></v-text-field>
          </template>
          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <div class="btn btn-secondary" @click="categoryCreateModal = false">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </div>
            <button class="btn btn-primary" @click="addCategory">
              <span>{{ $vuetify.lang.t('$vuetify.save') }}</span>
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>

    <v-dialog v-model="settingsModal">
      <div class="modal">
        <div class="h1">
          {{ $vuetify.lang.t("$vuetify.selectShownHeaders") }}
        </div>
        <v-form ref="form" @submit.prevent="">
          <v-checkbox v-for="header in headers" v-model="showHeaders[header.key]" :key="header.key"
                      :label="$vuetify.lang.t('$vuetify.' + header.name)"></v-checkbox>
          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <button class="btn btn-secondary" @click="settingsModal=false">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </button>
            <button class="btn btn-primary" @click="saveSettings">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>
    <ConfirmModal v-model="confirmModal" @confirm="deleteEntity">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>
    <ConfirmArchiveModal v-model="confirm_archive_modal" @confirm="archiveProduct" :active="newProduct.active">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmArchiveModal>

    <SpinnerLoader :overlay="loader"></SpinnerLoader>
  </div>
</template>

<script>
import SpinnerLoader from "@/components/SpinnerLoader";
import EditIcon from "@/components/icons/EditIcon";
import DeleteIcon from "@/components/icons/DeleteIcon";
import ConfirmModal from "@/components/confirmModal";
import ArchiveIcon from "@/components/icons/ArchiveIcon";
import ConfirmArchiveModal from "@/components/ConfirmArchiveModal";
import draggable from 'vuedraggable';
import PerPageSelect from "@/components/PerPageSelect.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "CatalogList",
  components: {
    PerPageSelect,
    ConfirmArchiveModal,
    ArchiveIcon,
    ConfirmModal,
    DeleteIcon,
    EditIcon,
    SpinnerLoader,
    draggable,
  },
  data: function () {
    return {
      type: localStorage.getItem("type_catalog") ?? (window.screen.width < 600 ? "cards" : "cards"),
      arch: false,
      sort: "name",
      search: "",
      filter: "",

      shops: [],
      sellers: [],
      products: [],
      categories: [],

      newShop: {},
      shopModal: false,

      newSeller: {},
      sellerModal: false,

      photo: null,
      newProduct: {
        name: {},
        active: true,
      },
      productCreateModal: false,
      newCategory: {},
      oldCategory: {},
      categoryCreateModal: false,

      confirmModal: false,
      confirm_archive_modal: false,
      chosen: null,
      table: '',
      measurements: [
        'kg',
        'g',
        'm',
        'm2',
        'm3',
        'pc',
        'rll'
      ],

      action: 'add',
      headers: [
        {key: "name", name: 'name2'},
        {key: "product_code", name: 'productCode'},
        {key: "price", name: 'accounting.card.price'},
        {key: "ean_code", name: 'eanCode'},
        {key: "description", name: 'description'},
      ],
      showHeaders: {},
      inHeight: 0,
      notruncate: 0,
      alertError: false,
      alertMsg: '',
      loader: false,
      width: screen.width,
      settingsModal: false,
      tableSettings: {},

      page: 1,
      perPage: Number(localStorage.getItem("per_page") ?? 24),
      length: 0,
    }
  },

  watch: {
    filter: function () {
      this.loadData()
    },
    sort: function () {
      this.loadData()
    },
    arch: function () {
      this.loadData()
    },
    type: function (val) {
      localStorage.setItem("type_catalog", val);
    },
    perPage: function () {
      if ((this.page * this.perPage) > (this.page * this.products.length))
        this.page = 1
      this.loadData()
    },
  },

  created: function () {
    this.checkPermission('Каталог').then(()=>{
      this.loadData();
      this.loadSettings();
    })
  },

  methods: {
    ...mapActions(['checkPermission']),
    loadData: function () {
      this.loader = true
      this.$axios({
        url: this.$hostname + "time-tracking/catalog",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        params: {
          arch: !this.arch,
          sort: this.sort,
          search: this.search,
          filter: this.filter ? this.filter.eng : '',
          page: this.page,
          per: this.perPage
        }
      }).then((response) => {
        this.products = response.data.data.products
        this.shops = response.data.data.shops
        this.sellers = response.data.data.sellers
        this.categories = response.data.data.categories
        this.length = response.data.data.pages
      }).catch((err) => {
        this.alertMsg = this.$catch(err);
        this.alertError = true;
      }).then(() => {
        this.loader = false
      })
    },
    loadSettings() {
      this.$axios({
        url: this.$hostname + "time-tracking/user-settings/table-settings",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.tableSettings = response.data.data.data
        if (response.data.data.data && response.data.data.data.catalog) {
          this.showHeaders = response.data.data.data.catalog
        } else
          this.showHeaders = {
            name: true,
            product_code: true,
            price: true,
            ean_code: true,
            description: true,
          }

        let order = []
        this.headers.forEach(header => {
          order.splice(this.showHeaders.order.indexOf(header.key), 0, header)
        })
        this.headers = order
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },

    addShop() {
      if (this.$refs.formShop.validate()) {
        this.loader = true
        this.$axios({
          url: this.$hostname + "time-tracking/catalog/shop" + (this.newShop.id ? ("/" + this.newShop.id) : ""),
          method: this.newShop.id ? "PUT" : "POST",
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
          data: this.newShop
        }).then(() => {
          this.loadData()
          this.shopCreateClose()
        }).catch((err) => {
          this.alertMsg = this.$catch(err);
          this.alertError = true;
        }).then(() => {
          this.loader = false
        })
      } else {
        this.alertMsg = this.$vuetify.lang.t('$vuetify.fillForm');
        this.alertError = true;
      }
    },
    shopCreateClose() {
      this.newShop = {}
      this.alertError = false
    },

    addSeller() {
      if (this.$refs.formSeller.validate()) {
        this.loader = true
        this.$axios({
          url: this.$hostname + "time-tracking/catalog/seller" + (this.newSeller.id ? ("/" + this.newSeller.id) : ""),
          method: this.newSeller.id ? "PUT" : "POST",
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
          data: this.newSeller
        }).then(() => {
          this.loadData()
          this.sellerCreateClose()
        }).catch((err) => {
          this.alertMsg = this.$catch(err);
          this.alertError = true;
        }).then(() => {
          this.loader = false
        })
      } else {
        this.alertMsg = this.$vuetify.lang.t('$vuetify.fillForm');
        this.alertError = true;
      }
    },
    sellerCreateClose() {
      this.newSeller = {}
      this.alertError = false
    },

    uploadPhoto() {
      if (this.photo) {
        this.$axios({
          url: this.$hostname + "time-tracking/images/upload/products",
          method: "POST",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: {
            file: this.photo,
          },
        }).then((response) => {
          this.newProduct.photo = response.data.data;
        }).catch((error) => {
          alert("Ошибка загрузки файла: " + error.message);
        }).finally(() => {
          this.addProduct()
        })
      } else {
        this.addProduct()
      }
    },
    addProduct() {
      if (this.$refs.formProduct.validate()) {
        this.loader = true
        this.newProduct.name = JSON.stringify(this.newProduct.name)
        this.newProduct.category = JSON.stringify(this.newProduct.category)
        this.$axios({
          url: this.$hostname + "time-tracking/catalog/product" + (this.newProduct.id ? ("/" + this.newProduct.id) : ""),
          method: this.newProduct.id ? "PUT" : "POST",
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
          data: this.newProduct
        }).then(() => {
          this.loadData()
          this.productCreateClose()
        }).catch((err) => {
          this.alertMsg = this.$catch(err);
          this.alertError = true;
          this.newProduct.product_name = JSON.parse(this.newProduct.product_name)
          this.newProduct.category = JSON.parse(this.newProduct.category)
        }).then(() => {
          this.loader = false
        })
      } else {
        this.alertMsg = this.$vuetify.lang.t('$vuetify.fillForm');
        this.alertError = true;
        this.loader = false
      }
    },
    archiveProduct() {
      this.loader = true
      this.$axios({
        url: this.$hostname + "time-tracking/catalog/product" + (this.newProduct.id ? ("/" + this.newProduct.id) : ""),
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          active: !this.newProduct.active
        }
      }).then(() => {
        this.loadData()
        this.confirm_archive_modal = false
      }).catch((err) => {
        this.alertMsg = this.$catch(err);
        this.alertError = true;
      }).then(() => {
        this.loader = false
      })
    },
    productCreateOpen() {
      this.action = 'add'
      this.productCreateModal = true
    },
    productCreateClose() {
      this.newProduct = {
        name: {},
        active: true,
      }
      this.photo = null
      this.alertError = false
      this.productCreateModal = false
    },

    addCategory() {
      if (this.$refs.category.validate()) {
        if (this.oldCategory.eng) {
          this.putCategory()
        }
        this.categories.push(this.newCategory)
        this.newProduct.category = this.newCategory
        this.categoryCreateModal = false
      } else {
        this.alertMsg = this.$vuetify.lang.t('$vuetify.fillForm')
        this.alertError = true
      }
    },
    putCategory() {
      let editable = this.products.find(product => product.category == this.oldCategory)
      this.$axios({
        url: this.$hostname + "time-tracking/products/categories",
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          category: JSON.stringify(this.newCategory),
          products: JSON.stringify(editable)
        }
      }).then(() => {
        this.loadData()
        this.oldCategory = {}
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    categoryCreateOpen() {
      let locales = Object.keys(this.$vuetify.lang.locales)
      locales.forEach(loc => {
        this.newCategory[loc] = ""
      })
      this.categoryCreateModal = true
    },
    categoryEditOpen(category) {
      this.newCategory = this.categories.find(cat => cat == category)
      this.oldCategory = structuredClone(this.newCategory)
      this.categoryCreateModal = true
    },

    deleteEntity() {
      this.$axios({
        url: this.$hostname + "time-tracking/catalog/" + this.table + "/" + this.chosen,
        method: "DELETE",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {id: this.chosen},
      }).then(() => {
        this.loadData()
        this.confirmModal = false
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    confirmOpen(id, table) {
      this.chosen = id
      this.table = table
      this.confirmModal = true
    },

    truncate(id) {
      let text = null
      if (this.type == 'rows')
        text = document.getElementById('item' + id)
      else
        text = document.getElementById('item-card' + id)
      this.notruncate = this.notruncate == id ? 0 : id
      this.inHeight = text.clientHeight
    },

    saveSettings() {
      let order = []
      this.headers.forEach(header => {
        order.push(header.key)
      })
      this.showHeaders.order = order
      this.tableSettings.catalog = this.showHeaders
      this.$axios({
        url: this.$hostname + "time-tracking/user-settings/table-settings",
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          table_settings: JSON.stringify(this.tableSettings)
        }
      }).then(() => {
        this.settingsModal = false
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    set_sort(field) {
      if (this.sort.includes(field) && this.sort[0] != '-') {
        this.sort = '-' + field
      } else {
        this.sort = field
      }
    },
  },

  computed: {
    ...mapGetters(['permissions'])
  }

}
</script>

<style scoped>

</style>